document.writeln('<link rel="stylesheet" type="text/css" href="/libs/vendor/jquery/uploadify/uploadify.css" />');

$(function() {
  var files = jQuery("input[type=file].uploadify");
  if (!swfobject.hasFlashPlayerVersion("9.0.124")) {
    files.on("change", function() {
      $(this.form).trigger("submit");
    });
    return;
  }
  files.each(function(index,element) {
    var uploadifyElement = this;
    jQuery(uploadifyElement).uploadify({
      "uploader"       : "/libs/vendor/jquery/uploadify/uploadify.swf",
      "cancelImg"   : "/libs/vendor/jquery/uploadify/cancel.png",
      "simUploadLimit" : 4,
      "script"         : element.form.action,
      "auto"           : true,
      "multi"          : true,
      "fileDataName"   : element.name,
      "wmode"          : "transparent",
      "onSelectOnce"   : function(event, data) {
        var scriptData = {"uploadify": true};
        for(var i=0; i<element.form.elements.length; i++) if(element.form.elements[i].name != element.name && element.form.elements[i].name != "") {
          if(element.form.elements[i].type != "checkbox" || element.form.elements[i].checked) {
            scriptData[element.form.elements[i].name] = element.form.elements[i].value;
          }
        }
        jQuery(uploadifyElement).uploadifySettings("scriptData", scriptData);
      },
      "onComplete": function(event, ID, fileObj, response, data) {
        var res = jQuery.parseJSON(response);
        if(res.error) {
          jQuery("#" + jQuery(element).attr("id") + ID + " .percentage").text(" - " + res.error);
          jQuery("#" + jQuery(element).attr("id") + ID).addClass("uploadifyError");
          return false;
        }
        eval(res.js);
        return true;
      },
      "onSelect": function(event, ID, fileObj) {
        jQuery(".uploadifyError").remove();
      }
    });
  });
});